<ng-container *hasPermission="['INSPECTION_CONFIGURATION_READ','INSPECTION_CONFIGURATION_ALL']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio configurazione - <b>{{detail_title}}</b></h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">

                <div class="col-md-6">
                    <label for="name" class="form-label">Tipologia</label>
                    <select class="form-select" aria-label="Tipo" id="type" name="type"
                        [(ngModel)]="inspectionConfiguration.provider" required (change)="onProviderChange()">
                        <option selected value=""></option>
                        <option *ngFor="let inspectionProvidersType of inspectionProvidersTypes"
                            [value]="inspectionProvidersType.id">
                            {{inspectionProvidersType.description}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label for="active" class="form-label">Attiva</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="active" name="active"
                            [(ngModel)]="inspectionConfiguration.active" />
                    </div>
                    <div class="form-text">Attivandola, le altre configurazioni della stessa tipologia verranno disattivate.</div>
                </div>
            </div>
            <ng-container *ngIf="inspectionAuth=='InspectionConfigBaseAuth' ">
                <app-base-auth-configs [authConfig]="authConfigBaseAuth"></app-base-auth-configs>
            </ng-container>
            <ng-container *ngIf="inspectionAuth=='ANPRInspectionConfigAuth' ">
                <app-anpr-auth-configs [authConfig]="authConfigBaseAuth" ></app-anpr-auth-configs>
            </ng-container>

            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>

                <ng-template [hasPermission]="['INSPECTION_CONFIGURATION_DELETE', 'INSPECTION_CONFIGURATION_ALL']">
                    @if (inspectionConfiguration.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['INSPECTION_CONFIGURATION_UPDATE', 'INSPECTION_CONFIGURATION_ALL']">
                    @if (inspectionConfiguration.id !== undefined) {

                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['INSPECTION_CONFIGURATION_CREATE', 'INSPECTION_CONFIGURATION_ALL']">
                    @if (inspectionConfiguration.id === undefined) {
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }

                </ng-template>
            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="'Eliminazione camera - '+confirmationMessage"
            [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>

</ng-container>